var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('label',{staticClass:"ts-mb-0"},[_vm._v(_vm._s(_vm.$t('productProfile.addOnItem')))]),_c('a-select',{staticClass:"ts-w-full",attrs:{"mode":"multiple","maxTagCount":10,"options":_vm.recipeList,"showSearch":"","filterOption":(input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0,"disabled":_vm.model.product_type_id == 3},model:{value:(_vm.model.recipes),callback:function ($$v) {_vm.$set(_vm.model, "recipes", $$v)},expression:"model.recipes"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }